import get from 'lodash/get';
import pickFP from 'lodash/fp/pick';
import groupBy from 'lodash/groupBy';

const pickFromSuggest = pickFP(['id', 'type', 'src', 'rel', 'mode']);

const HAPI_SUGGEST_SEARCH_MODES = {
  DIRECT: 'd',
  TRANSLIT: 't',
  LAYOUT: 'l',
  SUGGEST: 's',
  TRANSLIT_METAPHONE: 'tm',
  ANY: '*',
};

const prepareSuggest = (suggest) => {
  const suggestObj = {
    ...pickFromSuggest(suggest),
  };

  switch (suggest.type) {
    case 'country': {
      suggestObj.name = suggest.country;
      suggestObj.code = suggest.country_code;
      suggestObj.text = suggest.country;
      break;
    }
    case 'hotel': {
      suggestObj.name = suggest.name;
      suggestObj.countryName = suggest.country;
      suggestObj.countryId = suggest.country_id || suggest.country_code; // todo use only id when back is ready
      suggestObj.countryCode = suggest.country_code;
      suggestObj.cityName = suggest.city_name;
      suggestObj.cityId = suggest.city_id;
      suggestObj.text = suggest.name;
      suggestObj.country = `${suggest.country}, ${suggest.city_name}`;
      break;
    }
    default: {
      suggestObj.name = suggest.name;
      suggestObj.countryName = suggest.country;
      suggestObj.countryCode = suggest.country_code;
      suggestObj.countryId = suggest.country_id;
      suggestObj.text = suggest.name;
      suggestObj.country = suggest.country;
    }
  }

  return suggestObj;
};

const srcPriority = {
  [HAPI_SUGGEST_SEARCH_MODES.DIRECT]: 5,
  [HAPI_SUGGEST_SEARCH_MODES.TRANSLIT]: 4,
  [HAPI_SUGGEST_SEARCH_MODES.LAYOUT]: 3,
  [HAPI_SUGGEST_SEARCH_MODES.SUGGEST]: 2,
  [HAPI_SUGGEST_SEARCH_MODES.TRANSLIT_METAPHONE]: 1,
  [HAPI_SUGGEST_SEARCH_MODES.ANY]: 0,
};

const getGroupPriority = (type) => get(srcPriority, type, HAPI_SUGGEST_SEARCH_MODES.ANY);
const srcGroupSort = (a, b) => getGroupPriority(b) - getGroupPriority(a);
const relItemSort = (a, b) => b.rel - a.rel;

const sortSuggests = (items) => {
  items.forEach((item) => {
    if (item.mode) {
      // eslint-disable-next-line no-param-reassign
      item.src = item.mode;
    }
  });

  const groups = groupBy(items, 'src');
  const groupsOrder = Object.keys(groups).sort(srcGroupSort);

  const sortedSuggests = [];
  groupsOrder.forEach((groupName) => {
    groups[groupName][0].$groupStarter = true;
    const sortedGroupItems = groups[groupName].sort(relItemSort);

    sortedSuggests.push(...sortedGroupItems);
  });

  return sortedSuggests;
};

export default (suggests) => {
  const preparedSuggests = suggests.map(prepareSuggest);

  return sortSuggests(preparedSuggests);
};
